// 환경변수에서 가져온 API_BASE_URL을 정규화 (슬래시 제거)
const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';
export const API_BASE_URL = rawApiBaseUrl;

export const AUTHENTICATE_API_URL = '/authenticate';
export const COMMON_CODE_API_URL = '/common-codes';
export const CART_API_URL = '/cart';
export const CART_ITEM_API_URL = '/cart/items';
export const FILE_API_URL = '/files';
export const MENU_API_URL = '/menus';
export const ORDER_API_URL = '/orders';
export const PRODUCT_API_URL = '/products';
export const PRODUCT_QNA_API_URL = '/qnas/products';
export const PRODUCT_REVIEW_API_URL = '/reviews/products';
export const REVIEW_API_URL = '/reviews';
export const REFUND_API_URL = '/refunds';
export const SELLER_API_URL = '/sellers';
export const ADMIN_SELLER_API_URL = '/admin/sellers';
export const SELLER_PRODUCT_API_URL = '/seller/products';
export const TEMP_IMAGE_API_URL = '/temp-images';
export const USER_API_URL = '/users';
export const EYET_API_URL = '/eyet';
export const TOKEN_API_URL = '/me/tokens';
export const TERM_API_URL = '/term';
export const ADMIN_TERM_API_URL = '/admin/term';
export const IDENTITY_API_URL = '/identity/verification';
